export type ComprovantesSindicatoRow = {
  id: number;
  cnpj: string | null;
  sigla: string | null;
  solicitacao: string;
  situacao: string;
  envio: string | null;
  solicitacaoCorrecao: string | null;
  correcao: string | null;
  envioFormulario: string | null;
  idSindicato: number | null;
  /** extratoId da API — usado no GET /extratos/{id} (V2). */
  solicitacaoId: number | null;
  extratoId: number | null;
  ano: number;
  /** Quando false, bloqueia edição com tooltip de aceite do extrato. */
  envioHabilitado: boolean;
  bloqueado: boolean;
  historicoHabilitado: boolean;
  rowKey: string;
};

export const ALL_SITUATIONS_COMPROVANTES_SINDICATO = [
  "Comprovantes pendentes",
  "Comprovantes enviados",
  "Correção pendente",
  "Assinatura pendente",
  "Assinatura expirada",
  "Assinatura Concluída",
  "Inapto",
] as const;

export type SituacaoComprovanteSindicato =
  (typeof ALL_SITUATIONS_COMPROVANTES_SINDICATO)[number];
